import React from 'react';
import R2Image from '@/components/ui/R2Image';
import { animateTextChildren } from './textAnimator';

export const getMarkdownComponents = (
  isExpanded: boolean,
  startPos: number,
  counter: { count: number },
) => {
  return {
    desktopComponents: {
      p: ({ children }: any) => (
        <p className="font-mulish text-text-body mb-4 w-full text-[16px] leading-[24px] tracking-normal last:mb-0 md:text-[15px] md:leading-[22px] lg:text-[16px] lg:leading-[24px] xl:text-[17px] xl:leading-[28px]">
          {animateTextChildren(children, isExpanded, startPos, counter)}
        </p>
      ),
      strong: ({ children }: any) => (
        <strong className="text-text-brand font-bold">
          {animateTextChildren(children, isExpanded, startPos, counter)}
        </strong>
      ),
      ul: ({ children }: any) => (
        <ul className="mb-4 list-disc space-y-1 pl-5">{children}</ul>
      ),
      li: ({ children }: any) => (
        <li className="text-body text-text-body font-normal">
          {animateTextChildren(children, isExpanded, startPos, counter)}
        </li>
      ),
      img: ({ src, alt, title }: any) => {
        const [width, height] = title?.split('x').map(Number) || [20, 20];
        const imagePath = typeof src === 'string' ? src : '';
        return (
          <span className="mx-1 inline-block align-middle">
            <R2Image
              path={imagePath || ''}
              alt={alt || ''}
              width={width}
              height={height}
            />
          </span>
        );
      },
    },
    mobileComponents: {
      p: ({ children }: any) => (
        <p className="inline">
          {animateTextChildren(children, isExpanded, startPos, counter)}
        </p>
      ),
      strong: ({ children }: any) => (
        <strong className="text-text-brand font-bold">
          {animateTextChildren(children, isExpanded, startPos, counter)}
        </strong>
      ),
      ul: ({ children }: any) => (
        <ul className="mb-4 inline-block w-full list-disc space-y-1 pl-5">
          {children}
        </ul>
      ),
      li: ({ children }: any) => (
        <li className="text-body text-text-body font-normal">
          {animateTextChildren(children, isExpanded, startPos, counter)}
        </li>
      ),
      img: ({ src, alt, title }: any) => {
        const [width, height] = title?.split('x').map(Number) || [20, 20];
        const imagePath = typeof src === 'string' ? src : '';
        return (
          <span className="mx-1 inline-block align-middle">
            <R2Image
              path={imagePath || ''}
              alt={alt || ''}
              width={width}
              height={height}
            />
          </span>
        );
      },
    },
  };
};
export default getMarkdownComponents;
